/**
 * Showroom Callout Guard
 * Keeps showroom callouts visible after variant/swatch morph updates.
 */
(function() {
  'use strict';

  var calloutMarkupByHostKey = new Map();
  var restoreTimer = null;

  function getHostKey(host) {
    if (!host) return '';
    return host.getAttribute('data-showroom-host-key') || '';
  }

  function snapshotCallouts() {
    var eligibleHosts = document.querySelectorAll('.buy-buttons-block[data-showroom-eligible="true"][data-showroom-host-key]');

    eligibleHosts.forEach(function(host) {
      var hostKey = getHostKey(host);
      if (!hostKey) return;

      var callout = host.querySelector('[data-showroom-callout]');
      if (callout) {
        calloutMarkupByHostKey.set(hostKey, callout.outerHTML);
      }
    });

    document.querySelectorAll('.buy-buttons-block[data-showroom-host-key]:not([data-showroom-eligible="true"])').forEach(function(host) {
      var hostKey = getHostKey(host);
      if (hostKey) {
        calloutMarkupByHostKey.delete(hostKey);
      }
    });
  }

  function restoreCallouts() {
    snapshotCallouts();

    document.querySelectorAll('.buy-buttons-block[data-showroom-eligible="true"][data-showroom-host-key]').forEach(function(host) {
      if (host.querySelector('[data-showroom-callout]')) return;

      var hostKey = getHostKey(host);
      if (!hostKey) return;

      var calloutMarkup = calloutMarkupByHostKey.get(hostKey);
      if (!calloutMarkup) return;

      host.insertAdjacentHTML('beforeend', calloutMarkup);
    });
  }

  function queueRestore(delay) {
    if (restoreTimer) clearTimeout(restoreTimer);
    restoreTimer = setTimeout(function() {
      restoreCallouts();
    }, delay || 0);
  }

  function onVariantishEvent() {
    queueRestore(0);
    setTimeout(restoreCallouts, 120);
    setTimeout(restoreCallouts, 320);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreCallouts);
  } else {
    restoreCallouts();
  }

  document.addEventListener('variant:selected', onVariantishEvent);
  document.addEventListener('variant:update', onVariantishEvent);
  document.addEventListener('morph:complete', onVariantishEvent);
  document.addEventListener('main:morphed', onVariantishEvent);
  document.addEventListener('shopify:section:load', onVariantishEvent);

  var observer = new MutationObserver(function() {
    queueRestore(50);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setInterval(restoreCallouts, 2000);
})();
